<template>
  <div class="box orders-line">
    <div class="ys_chart_title flex justify-between items-center">
      <span> 数量统计</span>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ TIME_LIST[state] }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="index" v-for="(item,index) in TIME_LIST" :key="index">{{item}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div id="timechart"></div>
  </div>
</template>
<script>
import { TIME_LIST } from "@/common/constants/resources";
export default {
  data() {
    return {
      TIME_LIST: TIME_LIST,
      myChart: null,
      option: {},
      data: [],
      data2: [],
      data_type: [],
      mintime: 0,
      state: 1,
    };
  },
  mounted() {
    this.mintime = new Date(new Date() - 600000).getTime();
    this.getLoadEcharts();
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    handleCommand(command) {
      this.state=command
      this.getList()
    },
    settime_down() {
      setInterval(() => {
        this.getList();
      }, 600000);
    },

    getLoadEcharts() {
      this.myChart = this.$echarts.init(document.getElementById("timechart"));
      this.getList();
      this.option = {
        colors: ["#5470C6", "#EE6666"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            animation: false,
          },
        },
        xAxis: [
          {
            type: "time",
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: {
          type: "value",
          boundaryGap: [0, "100%"],
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "新增场所数",
            type: "line",
            smooth: true,
            showSymbol: false,
            data: this.data,
          },
          {
            name: "新增隐患数",
            type: "line",
            stack: "Total",
            data: this.data2,
          },
        ],
      };
      this.myChart.setOption(this.option);
      this.settime_down();
    },
    getList() {
      this.$_invoke("home_dynamic",{
        state:this.state
      }).then((res) => {
        const count = res.$count;
        const key = Object.keys(count);
        this.data = [];
        this.data2 = [];
        key.map((v) => {
          this.data.push({
            name: v,
            value: [v, count[v].place_new_count],
          });
          this.data2.push({
            name: v,
            value: [v, count[v].hidden_new_count],
          });
        });
        this.myChart.setOption({
          series: [
            {
              data: this.data,
            },
            {
              data: this.data2,
            },
          ],
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
}
#echart {
  width: 100%;
  height: 100%;
}
.orders-line {
  #timechart {
    width: 100%;
    height: 400px;
    margin-bottom: 20px;
  }
}
</style>